import axios from 'axios';
// import axios from '../../../utils/axios';

const baseUrl = window.config.API_URL;
// registerUser user
const registerUser = async (userData) => {
  const path = '/api/user/register';
  const url = baseUrl + path;
  const response = await axios.post(url, userData);
  return response?.data;
};

// two factor auth
const twofactorAuth = async (userData) => {
  // const path = '/api/user/';
  // const url = baseUrl + path;
  // const response = await axios.post(url, userData);
  // return response?.data;
};

// loginUser user
const loginUser = async (userData) => {
  try {
    const path = '/api/user/login';
    const url = baseUrl + path;

    const response = await axios.post(url, userData);
    localStorage.setItem('user', JSON.stringify(response.data));

    return response.data;
  } catch (error) {
    console.error(error.message);
  }
};

// loginUser user
const resetUserPassword = async (userDatas) => {
  try {
    const path = '/api/user/send-reset-password-email';
    const url = baseUrl + path;

    const response = await axios.post(url, userDatas);
    return response.data;
  } catch (error) {
    console.error(error.message);
  }
};

// logoutUser user
const logoutUser = async () => {
  try {
    const path = '/api/user/logout';
    const url = baseUrl + path;

    localStorage.removeItem('user');
    localStorage.removeItem('linkId');
    localStorage.removeItem('linkData');

    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    console.error(error.message);
  }
};


const twoFactorAuthentication = async () => {
  try {
    const user = JSON.parse(localStorage.getItem('user')) || '';
    const userID = user?.userid;
    const path = `/api/user/twofactorsetup/${userID}`;
    const url = baseUrl + path;
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    console.error(error.message);
  }
};

const verifyTwoFactor = async (data) => {
  try {
    const path = '/api/user/verify';
    const url = baseUrl + path;
    const user = JSON.parse(localStorage.getItem('user')) || '';
    const userID = user?.userid;
    const payload = {
      userToken: data,
      userId:userID
    };

    const response = await axios.post(url, payload);
    return response.data;
  } catch (error) {
    console.error(error.message);
  }
};
const contactUs = async (data) => {
  try {
    const path = '/api/user/contactUs';
    const url = baseUrl + path;

    const payload = {
      name: data?.name,
      email: data?.email,
      subject: data?.subject,
      message: data?.message,
    };
    const response = await axios.post(url, payload);
    return response.data;
  } catch (error) {
    console.error(error.message);
  }
};

const authService = {
  registerUser,
  logoutUser,
  loginUser,
  resetUserPassword,

  twofactorAuth,
  twoFactorAuthentication,
  verifyTwoFactor,

  contactUs,
};
export default authService;
